import apiRequestCommon from './index'

export default {
  path: '/v1/users/info/',
  async get (nativedata, appVersionHeader) {
    await window.callNativeHTTPX()
    let headersParam = {
      'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
      'HTTP-X-DAPP-USERID': window.DAPP_USERID,
      'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD,
      'APP-USERS-POPINFO-ID': nativedata.popinfoid,
      'APP-USERS-INTEC-TSID': nativedata.tsid,
      'APP-USERS-INTEC-OTOKEN': nativedata.otoken,
      'X-CLS-App-Version': appVersionHeader
    }
    // ローカルは認証情報を参照しないように変更する
    if (process.env.VUE_APP_LOCAL === 'true') {
      headersParam = {
        'HTTP-X-DAPP-USERID': '93aba821-2e63-482b-af97-**********',
        'HTTP-X-DAPP-REQUESTTIME': '1562043459',
        'HTTP-X-DAPP-AUTHCD': '9f4fa2f510ca52e19e2e63**************************',
        'APP-USERS-POPINFO-ID': '23c5906c-aeb0-45db-a3f2-ba5a0849e4c5',
        'APP-USERS-INTEC-TSID': '1234567890123456789012345678901234567890123',
        'APP-USERS-INTEC-OTOKEN': '12345678901234567890123456789012',
        'X-CLS-App-Version': '3.3.1/Android/5.0.2'
      }
    }
    return apiRequestCommon.get(this.path, {
      headers: headersParam
    })
  }
}
